import React from 'react';
import ContactForm from './ContactForm';

const ContactSection = () => {
    const data = {
        heading: "Ready to Transform Your Business?",
        headingText: "Connect with our team of technology experts and discover how MobiCloud can help you achieve your digital transformation goals.",
        headingTexttwo: "Let's discuss your project and explore innovative solutions together.",
        content: "Our experienced team is ready to understand your unique challenges and provide tailored solutions that drive real business results. From initial consultation to implementation and ongoing support, we're here to ensure your success.",
        iconList: [
            {
                iconClass: "fas fa-envelope",
                text: "admin@mobicloud.ai"
            }
        ]
    };

    return (
        <section id="contact" className="contact-area bg-gray ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{data.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{data.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{data.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-between">
                    <div className="col-12 col-md-5">
                        {/* Contact Us */}
                        <div className="contact-us">
                            <p className="mb-3">{data.content}</p>
                            <ul>
                                {data.iconList.map((item, idx) => (
                                    <li key={idx} className="py-2">
                                        <a className="media" href="/#">
                                            <div className="social-icon mr-3">
                                                <i className={item.iconClass} />
                                            </div>
                                            <span className="media-body align-self-center">{item.text}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 pt-4 pt-md-0">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection; 